import React from 'react';
import Head from 'next/head';
import directory from '@tutorbot/directory-api';
import { LocationContext } from '../../hoc/Location';
import { LocalizationContext } from '../../hoc/Localization';
import { getCourses } from '../../utils/directory';
import CardList from '../../components/CardList';
import TitleContent from '../../components/TinyComponents/TitleContent';
import styles from './styles.less';
import Container from '../../components/Home/Container';

const Discount = () => {
  const { countries } = React.useContext(LocationContext);
  const { t } = React.useContext(LocalizationContext);
  const [categories, setCategories] = React.useState([]);
  const [datadiscounted, setDataDiscounted] = React.useState([]);

  React.useEffect(() => {
    (async () => {
      setCategories((await directory().categories.get()).data.map(it => it.label));
    })();
  }, []);

  React.useEffect(() => {
    (async () => {
      categories.forEach(async it => {
        const { data } = await getCourses({
          filters: { countries, category: it, type: 'discounted' },
          limit: 3,
        });
        datadiscounted.push({ category: it, data });
        setDataDiscounted([...datadiscounted]);
      });
    })();
  }, [categories]);
  return (
    <div className={styles.container}>
      <Head>
        <title>{`${t('meta.title.suffix')} | ${t('meta.title.front')}`}</title>
        <meta name="description" content={t('meta.description.front')} />
      </Head>
      {datadiscounted.map(
        it =>
          it.category &&
          it.data[0] && (
            <Container>
              <TitleContent
                title={
                  <>
                    <h2>{t(`frontpage.courses.discount.${it.category}.title`)}</h2>
                    <p className={styles.subTitle}>
                      {t(`frontpage.courses.discount.${it.category}.description`)}
                    </p>
                  </>
                }
                content={
                  <CardList
                    data={it.data}
                    moreButtonId="more"
                    filters={{ category: it.category, discountedPrice: true }}
                  />
                }
              />
            </Container>
          ),
      )}
    </div>
  );
};

export default Discount;
